import { render, staticRenderFns } from "./losing.vue?vue&type=template&id=49461480&scoped=true"
import script from "./losing.vue?vue&type=script&lang=js"
export * from "./losing.vue?vue&type=script&lang=js"
import style0 from "./losing.vue?vue&type=style&index=0&id=49461480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49461480",
  null
  
)

export default component.exports